import React, { FC } from 'react';
import { StyledSection, StyledTextPairing } from './RegistryFaqSection.styles';
import { FaqList, QuestionNodeType } from '@components/FaqList';
import { useTranslation } from 'react-i18next';

interface RegistryFaqSectionProps {
  questionNodes: readonly QuestionNodeType[];
}

export const RegistryFaqSection: FC<RegistryFaqSectionProps> = ({ questionNodes }) => {
  const { t } = useTranslation('registry');
  const registryFaqSection = t('registryFaqSection');

  return (
    <StyledSection as="section" id="RegistryFaqSection">
      <StyledTextPairing
        alignment="center"
        title={registryFaqSection.title}
        titleTagName="h2"
        titleColor="mono1"
        titleVariant="hed56"
        body={registryFaqSection.body}
        bodyColor="mono1"
        bodyVariant="featureCopy17"
      />
      <FaqList
        accordion={true}
        questionNodes={questionNodes}
        color="mono1"
        isLinkHidden={true}
        iconColor="mono1"
        titleVariant="featureCopy17"
        variant="secondary"
      />
    </StyledSection>
  );
};
